export default {
    edit_swap_sim_card_title: "Complete Setup",
    edit_swap_sim_card_sim_details_error: "It was not possible to get the detail of the sim",
    edit_swap_sim_card_saved_successfully: "Saved Successfully",
    edit_swap_sim_card_the_was_an_error_in_the_save: "There was an error in the save",
    edit_swap_sim_card_device_imei: "Device IMEI",
    edit_swap_sim_card_device_esn: "Device ESN",
    edit_swap_sim_card_sim_provider_account: "SIM Provider Account",
    edit_swap_sim_card_sim_sim_phone: "Sim Phone",
    edit_swap_sim_card_load_phone_number: "Load Phone #",
    edit_swap_sim_card_iccid_minlength: "ICCID should be 14-20 characters",
}